export default __webpack_public_path__ + "static/media/logo_black_icon.d36dd3c3.svg";